<template>
  <div>
    <div
      class="d-flex justify-content-center"
      style="width: 100%"
      v-if="loading"
      v-cloak
    >
      <grid-loader
        :loading="loading"
        :color="spinerColor"
        :size="spinerSize"
      ></grid-loader>
    </div>

    <div class="justify-content-center">
      <form class="needs-validation" novalidate v-on:submit.prevent="save">
        <div class="form-group">
          <input
            name="email"
            type="text"
            class="form-control"
            v-model="feedback.email"
            v-validate="'required|email'"
            :class="{ 'is-invalid': errors.has('email') }"
            :placeholder="$t('youremail')"
          />
          <div class="invalid-email">{{ errors.first("email") }}</div>
        </div>

        <div class="form-group">
          <input
            type="text"
            name="name"
            class="form-control"
            v-validate="'required'"
            v-model="feedback.name"
            :placeholder="$t('yourname')"
            :class="{ 'is-invalid': errors.has('name') }"
          />
          <div class="invalid-name">{{ errors.first("name") }}</div>
        </div>

        <div class="form-group">
          <textarea
            class="form-control"
            rows="10"
            name="message"
            v-validate="'required'"
            v-model="feedback.message"
            :placeholder="$t('yourmessage')"
            :class="{ 'is-invalid': errors.has('message') }"
          >
          </textarea>
          <div class="invalid-message">{{ errors.first("message") }}</div>
        </div>

        <div>
          <button type="submit" class="btn btn-primary">
            {{ $t("send") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<i18n>
  {
    "en":{
      "send":"Send",
      "youremail":"Your Email",
      "yourname": "Your Name",
      "yourmessage":"How may we help you?",
      "checkForm":"Correct the errors!",
      "saveSuccess":"Success."
    },
    "cn":{
      "send":"发送",
      "youremail":"您的邮箱",
      "yourname": "您的名字",
      "yourmessage":"请写下您的问题或意见。",
      "checkForm":"填写的内容有误，请检查。",
      "saveSuccess":"保存成功"
    }
  }
</i18n>
<script>
export default {
  mounted() {
    console.log("Feedback mounted.");
    const self = this;
  },

  watch: {
    locale(val) {
      this.$i18n.locale = val;
    }
  },
  data() {
    return {
      locale: "en",
      spinerSize: "8px",
      spinerColor: "#dc3545",
      loading: false,
      feedback: {
        email: null,
        name: null,
        message: null
      }
    };
  },

  methods: {
    save: function() {
      const self = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log(self.feedback);

          this.$http
            .post("/api/feedback", this.feedback)
            .then(response => {
              self.$notify({
                group: "app",
                text: self.$i18n.t("saveSuccess"),
                type: "success"
              });
            })
            .catch(e => {
              console.error(e);
            });
          return;
        }

        self.$notify({
          group: "app",
          text: self.$i18n.t("checkForm"),
          type: "warn"
        });
      });
    }
  }
};
</script>
